import { render, staticRenderFns } from "./SearchInChannel.vue?vue&type=template&id=7a38c74a&scoped=true&lang=pug"
import script from "./SearchInChannel.vue?vue&type=script&lang=js"
export * from "./SearchInChannel.vue?vue&type=script&lang=js"
import style0 from "./SearchInChannel.vue?vue&type=style&index=0&id=7a38c74a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38c74a",
  null
  
)

export default component.exports